"use client";

import { updateSoundboard } from "@/app/_api/soundboards";
import { SocialShareButton } from "@ui/components/core/SocialShareButton";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

import { useSoundboard } from "../state/reducer";

export const ShareButton = () => {
  const { state } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");
  const preset = useMemo(() => {
    return state.presets[state.activePresetId!];
  }, [state.activePresetId, state.presets]);

  const shareLink = useMemo(() => {
    return `${window.location.origin}/sound-effects/soundboard${preset?.savedBoardId ? `?soundboardId=${preset.savedBoardId}` : ""}`;
  }, [preset]);

  if (state.user === undefined) {
    return null;
  }

  const sharePreset = async () => {
    if (!preset?.id) return;

    if (preset.isCreatedByMe && !preset.isPublic) {
      const token = await state.user?.getIdToken();
      if (!token) return;
      await updateSoundboard(preset.id, { public: true }, token);
    }
  };

  return (
    <SocialShareButton
      beforeShare={sharePreset}
      customTrigger={
        <button className='font-soundboard f-ui-04 w-full flex-1 rounded-sm border border-default px-16 py-12 disabled:opacity-50'>
          {t("preset_editor.share_preset")}
        </button>
      }
      label={t("preset_editor.share_preset")}
      url={shareLink}
    />
  );
};
